import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        scormSubmission: '=',
        viewOnly: '='
    },
    template: `
        <scorm-player-epub scorm-submission="vm.scormSubmission" view-only="vm.viewOnly" ng-if="vm.isEpub()"/>
        <scorm-player-scorm scorm-submission="vm.scormSubmission" view-only="vm.viewOnly" ng-if="vm.isScorm()"/>
    `
})
export default class {
    isEpub () {
        return this.scormSubmission.scorm.type === 'EPUB';
    }

    isScorm () {
        return this.scormSubmission.scorm.type !== 'EPUB';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/scorm/player/index.js